import axios from "axios"

export default async function archiveDocument(projectName, formName, data) {
    // const formData = new FormData();
    // data.file && formData.append("file", data.file);
    // data.reader && formData.append("reader", data.reader);

    const res = await axios.post(`/project/${projectName}/${formName}/archive-document`, data)
    return res;
}